<template>

  <div>

    <ui-prop-string name="title" title="Operation title" :block="block"/>
    <ui-prop-select :block="block" name="dbId" title="Database" :options="dbOptions"/>

    <template v-if="block?.properties?.dbId">
      <ui-prop-select v-if="!isTreeStorageSelected" :block="block" name="tableId" title="Table" :options="tablesList"/>
      <template v-else>
        <ui-prop-tree-storage-selector title="Property" name="updateProperty" :parent-id="treeStorageDbId" :block="block"/>

        <ui-prop-value-selector title="Parent" :block="block" name="parentId" only-var-type="tree-storage" value-type="variable" :parent-diagram-id="diagram_id" />
      </template>
    </template>


    <ui-prop-select v-if="block?.properties?.tableId" :block="block" name="saveMode" default-value="object" title="Save mode" :options="globals.options.dbSaveModes"/>

    <q-card class="q-mt-sm" v-if="block?.properties?.saveMode === 'fields' || (isTreeStorageSelected && block?.properties?.parentId)">
      <q-card-section class="bg-primary text-white">Fields list</q-card-section>
      <q-card-section v-if="block?.properties?.tableId || (isTreeStorageSelected && block?.properties?.parentId)" class="q-gutter-y-sm column">

        <div v-for="(field, key) of fieldsList" :key="key">
          <value-selector v-model="fields[field.name]" :title="`Field: ${field.name}`"
                          :only-var-type="convertDbType(field.type)"
                          :app-id="product_id" :module-id="module_id" :parent-diagram-id="diagram_id"
                          :block-id="block.id"
          />

          <q-separator spaced/>

        </div>

      </q-card-section>
    </q-card>

    <q-card class="q-mt-sm" v-if="block?.properties?.saveMode === 'object'">
      <ui-prop-value-selector :block="block" title="Object to save" name="object" value-type="getter" :parent-diagram-id="diagram_id"/>
    </q-card>

    <ui-prop-value-selector only-var-type="object,db-record" :block="block" title="Variable to save result" name="variableToSave" value-type="setter" :parent-diagram-id="diagram_id"/>

  </div>

</template>

<script>

import {propertiesMixins} from "@/components/DiagramDesigner/Editor/properties/propertiesMixins";
import {DbTableField} from "@/../../common/db/DbTableField";
import UiPropString from "@/components/DiagramDesigner/Editor/properties/UiPropString.vue";
import UiPropSelect from "@/components/DiagramDesigner/Editor/properties/UiPropSelect.vue";
import ValueSelector from "@/components/ValueSelector/ValueSelector.vue";
import UiPropValueSelector from "@/components/DiagramDesigner/Editor/properties/UiPropValueSelector.vue";
import {dbListMixin} from '../dbListMixin';
import {StorageNode} from '../../../../../../../../../common/db/StorageNode';
import UiPropTreeStorageSelector from '@/components/DiagramDesigner/Editor/properties/UiPropTreeStorageSelector.vue';

export default {
  mixins: [propertiesMixins, dbListMixin],
  components: {UiPropTreeStorageSelector, UiPropValueSelector, ValueSelector, UiPropSelect, UiPropString},
  inject: ["currentModule"],
  props: ['block'],
  name: "DbSavePropsCmp",

  data: () => ({
    fields: {}
  }),

  created() {
    // Init value
    if (this.currentValue) this.fields = this.currentValue

    // Add watcher
    this.$watch('fields', function (newVal) {
      this.currentValue = newVal
    }, {deep: true})
  },

  methods: {

    /**
     * Convert db type to var type
     * @param type
     * @return {*|string}
     */
    convertDbType(type) {
      switch (type) {
        case "autogenerated":
          return "string";
        default:
          return type;
      }
    }
  },

  computed: {
    type: () => "fields",

    /**
     * Fetches the list of database fields for the selected table.
     *
     * @returns {Promise<Array>} A promise that resolves to an array of database fields.
     */
    dbFields() {
      return this.wait("dbFields", DbTableField.query().where({table_id: this.block?.properties?.tableId || 0}).get(), []);
    },

    /**
     * Fetches the list of fields for the selected tree storage node.
     *
     * @returns {Promise<Array>} A promise that resolves to an array of fields.
     */
    treeStorageFields() {
      const parentId = this.block?.properties?.updateProperty;

      if (!parentId) {
        return [];
      }

      return this.wait('treeStorageFields', async () => {
        return [
          {name: 'id', type: 'string'},
          ...(await StorageNode.query().where({parent_id: parentId}).where(StorageNode.sql().notEq('is_array', 1)).get() || []),
        ];
      }, []);
    },

    /**
     * Get fields list
     * @return {*}
     */
    fieldsList() {
      return this.isTreeStorageSelected ? this.treeStorageFields : this.dbFields;
    },

    /**
     * Extracts the database ID from the block properties.
     *
     * @returns {number|undefined} The extracted database ID or undefined if not available.
     */
    treeStorageDbId() {
      const [,id] = String(this.block?.properties?.dbId || '').split(':');

      return id ? Number(id) : undefined;
    },
  }
}

</script>
